import styled, { css } from 'styled-components'
import ReactSelect from 'react-select'

const fontColor = '#787878'
const errorColor = '#d94646'
const blueColor = '#75B3CC'

export const VerticalsContainer = styled.div`
  min-width: 350px;
  width: 100%;
`

export const Info = styled.div`
  color: ${fontColor};
  font-size: 11px;
  line-height: 23px;
  padding: 2px 5px;
`

export const SupportText = styled.div`
  color: #787878;
  font-weight: 400;
  font-size: 11px;
  margin: 10px;
  text-align: center;
`

export const Separator = styled.div`
  width: 70%;
  margin: 10px auto;
  height: 1px;
  background: #919191;
`

export const Option = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
`

export const Button = styled.button`
  cursor: pointer;
  color: white;
  background: ${blueColor};
  padding: 3px 10px;
  border: none;
  box-shadow: none;
  margin: 0;
  text-transform: uppercase;
  font-size: 11px;
`

export const Value = styled.span`
  margin: 0 2px;

  &:not(:last-of-type) {
    &:after {
      content: ',';
    }
  }
`

export const Select = styled(ReactSelect)(
  ({ isValid, placeholder }) => css`
    .Select-control,
    &.is-focused:not(.is-open) .Select-control {
      border-color: ${isValid ? '#ccc' : errorColor};
    }

    &.has-value .Select-multi-value-wrapper {
      &:before {
        padding-left: 10px;
        content: "${placeholder}";
        font-weight: 700;
        color: ${fontColor};
      }
    }

    .Select-placeholder {
      font-weight: 700;
      color: ${fontColor};

      &:after {
        content: ${isValid ? '' : '"choose at least one"'};
        color: #d94646;
        font-weight: 400;
      }
    }
  `
)



// WEBPACK FOOTER //
// ./src/components/PollForm/VerticalTargeting/index.style.js